import { useLocation } from 'react-router-dom'
import haxios from '../lib/haxios'
import { useEffect, useState } from 'react'

// Create a simple event system for logout
const logoutEvent = new EventTarget()
export const triggerLogout = () => {
  logoutEvent.dispatchEvent(new Event('logout'))
}

const useAuth = () => {
  const [isLoading, setLoading] = useState(true)
  const [isAuthed, setAuthed] = useState(null)
  const location = useLocation()

  useEffect(() => {
    (async () => {
      const res = await checkAuth()
      setAuthed(res)
      setLoading(false)
    })()
  }, [location])

  // Listen for logout events
  useEffect(() => {
    const handleLogout = () => {
      setAuthed(false)
      setLoading(false)
    }

    logoutEvent.addEventListener('logout', handleLogout)
    return () => logoutEvent.removeEventListener('logout', handleLogout)
  }, [])

  const checkAuth = async () => {
    try {
      console.log('checkAuth')
      const res = await haxios.get('/auth/expired')
      if (res && res.error) return false
      return true
    } catch (e) {
      //console.log(e)
      return false
    }
  }

  return { isAuthed, authLoading: isLoading }
}

export default useAuth